<div class="teal-background white-font header">
  <span class="text-uppercase">Style Preview</span>
</div>
<div class="border flex-grow-1">
  <iframe [src]="portalUrl" class="portal-iframe"></iframe>
</div>
